import { render, staticRenderFns } from "./MenuExtras.vue?vue&type=template&id=25cdfeef&"
import script from "./MenuExtras.vue?vue&type=script&lang=js&"
export * from "./MenuExtras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports